module.exports = __webpack_public_path__ + "img/bImg1.3fadeb28.png";